module.exports = __webpack_public_path__ + "media/src/assets/img/portrait/small/avatar-s-10-c7eebd6b707086d0063fc288f3905042.jpg";